import React from 'react';
import COButton from 'shared/components/COButton';
import { ButtonSize } from 'enums/ButtonEnums';
import { ReactComponent as BackIcon } from 'assets/icons/back_arrow.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import styles from './adeHeader.module.scss';

interface ActivityDataEntryHeaderProps {
  locationName: string | undefined;
  locationCategory: string | undefined;
  isFirstFlow: boolean;
  isEditView: boolean;
  handleBack: () => void;
  handleCancelClick: () => void;
  handleProceedClickWrapper: () => void;
  handleDelete: () => void;
  canDeleteLocation?: boolean;
}

const ActivityDataEntryHeader: React.FC<ActivityDataEntryHeaderProps> = ({
  locationName,
  locationCategory,
  isFirstFlow,
  isEditView,
  handleBack,
  handleCancelClick,
  handleProceedClickWrapper,
  handleDelete,
  canDeleteLocation = true,
}) => {
  return (
    <div className={styles.headingContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.iconWrapper} onClick={handleBack}>
          <BackIcon />
        </div>
        <div className={styles.locationTitle}>
          Activity Data Entry - {locationName}
          <span>{`(${locationCategory})`}</span>
        </div>
      </div>
      {isFirstFlow ? (
        <div className={styles.buttonContainer}>
          <COButton
            secondary
            size={ButtonSize.SMALL}
            disabled={isEditView}
            onClick={handleCancelClick}>
            Cancel
          </COButton>
          <COButton
            primary
            size={ButtonSize.SMALL}
            disabled={isEditView}
            onClick={handleProceedClickWrapper}>
            Proceed
          </COButton>
        </div>
      ) : (
        <div className={styles.deleteButtonContainer}>
          <COButton
            icon={<DeleteIcon />}
            text
            onClick={handleDelete}
            disabled={!canDeleteLocation}>
            Delete location
          </COButton>
        </div>
      )}
    </div>
  );
};

export default ActivityDataEntryHeader;
